import { FC } from 'react';

import { Grid } from '@mui/material';

import TableList from 'src/components/TableList/TableList';
import { HISTORY_TABLE_HEADERS } from 'src/constants';

import { getDescription } from '../../utils/utils';

export interface HistoryProps {
    isMerchant?: boolean;
    auditLogs?: {
        id: number;
        activityType?: string;
        details?: string | Record<string, unknown>;
        createdAt: string;
        user: {
            firstName: string;
            lastName: string;
        };
        entity?: string;
    }[];
    isDashboardTable?: boolean;
    isHistoryTable?: boolean;
    isTableModal?: boolean;
}

const History: FC<HistoryProps> = ({
    auditLogs,
    isTableModal = true,
    isDashboardTable = true,
    isHistoryTable = true,
}) => {
    const tableData = auditLogs
        ?.map((log) => {
            const description = getDescription(log);

            if (!description) return null;

            const createdBy = log?.user ? `${log.user.firstName} ${log.user.lastName}` : 'System';

            return {
                id: log.id,
                description,
                dateCreated: log.createdAt,
                createdBy,
            };
        })
        .filter(Boolean);

    return (
        <Grid sx={{ display: 'flex', flexDirection: 'column', maxWidth: '100%' }}>
            <TableList
                title="History"
                isTableModal={isTableModal}
                isDashboardTable={isDashboardTable}
                isHistoryTable={isHistoryTable}
                data={tableData}
                headers={HISTORY_TABLE_HEADERS}
            />
        </Grid>
    );
};

export default History;
